module.exports = __webpack_public_path__ + "static/margaret-thatcher-5acbea1c3d8c90d4d50656e16cd23f3c.jpg";